import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiHome, FiCalendar, FiPackage, FiFileText } from "react-icons/fi";
import "./ComponentsStyles/MobileBottomNav.css";
import { RiStethoscopeFill } from "react-icons/ri";
import { TbReport } from "react-icons/tb";
import { TbTestPipe } from "react-icons/tb";

const MobileBottomNav = () => {
  const location = useLocation();

  const navItems = [
    { path: "/", label: "Home", icon: <FiHome /> },
    { path: "/doctors-grid", label: "Booking", icon: <RiStethoscopeFill /> },
    { path: "/test-packages", label: "Tests", icon: <TbTestPipe /> },
    { path: "/service/OurPackagesPage", label: "Packages", icon: <FiPackage /> },
    { path: "/view-reports", label: "Reports", icon: <TbReport /> },
  ];

  return (
    <nav className="mobile-bottom-nav">
      {navItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`nav-item ${location.pathname === item.path ? "active" : ""}`}
        >
          {item.icon}
          <span>{item.label}</span>
        </Link>
      ))}
    </nav>
  );
};

export default MobileBottomNav;
